"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ErrorDialogActions", {
  enumerable: true,
  get: function get() {
    return _ErrorDialogActions.ErrorDialogActions;
  }
});

var _ErrorDialogActions = require("./ErrorDialogActions");